import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { Trans } from "~/utils/i18next";
import { CollapsibleText } from "./CollapsibleText";
import { components } from "./contentComponents";
import { FaqGrouping } from "./FaqGrouping";

export const Content: FC = () => {
  const { t } = useTranslation();
  const user = useCurrentUser();

  const namespace = user ? ("memberSite" as const) : ("marketingSite" as const);
  const categoryKey = `faqs.${namespace}.categories` as const;
  const categories = t(categoryKey, { returnObjects: true }) as {
    title: string;
    faqs: { question: string; answer: string }[];
  }[];

  return (
    <>
      {categories.map((category) => (
        <FaqGrouping key={category.title} heading={category.title}>
          {category.faqs.map((faq, index) => (
            <CollapsibleText
              key={faq.answer}
              heading={faq.question}
              isLast={index === category.faqs.length - 1}
              text={<Trans components={components}>{faq.answer}</Trans>}
            />
          ))}
        </FaqGrouping>
      ))}
    </>
  );
};
